import { v4 as uuid } from "uuid";
import {BaseModel} from "./Base";

type Modals = {
  [key: string]: Modal;
};

type Modal = {
  key:string;
  type: string,
  data:any,
  options: any
};

    export class ModalModel extends BaseModel  {
        modals: Modals = {};
        current: Modal; 
        
        constructor(modalType:string = "") {
            super();
        }
        
      create( modalType:string = "", data:any = null, options: any = null) {
          let newKey = uuid().slice(0, 8);
          let modalObj:Modal = {
              key: newKey,
              type: modalType,
              data: data,
              options: options
          };
          this.current = modalObj;
          this.modals[modalObj.key] = modalObj;
          
          return modalObj;
      }

    }